import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { API } from "aws-amplify";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CONST_AWS_API } from "src/app/core/constants";
import { environment } from "src/environments/environment";
import { CommanSubscribeService } from "./../../../../../core/services/comman-subscribe.service";
import { Subscription } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { SendbirdService } from "src/app/core/services/sendbird.service";
import { DomSanitizer } from "@angular/platform-browser";
import { API as AWS_API } from "aws-amplify";
import { UserService } from "src/app/core/services/user.service";
import { PubNubService } from "src/app/core/services/pubnub.service";
declare let $: any;
@Component({
  selector: "app-networking-list",
  templateUrl: "./networking-list.component.html",
  styleUrls: ["./networking-list.component.scss"],
})
export class NetworkingListComponent implements OnInit {
  userInfo: any;
  key: any;
  rooms: any;
  event_id: any;
  networkInterval: any;
  networkUsers: [];
  usersCount: any;
  userInfoSubscription: Subscription;
  room_id: any;
  ticketInfo: any;
  sb: any;
  // isSendBirdChannelAvailable: boolean;
  // openSendBirdChannel: any;
  isPubNubChannelAvailable: Boolean;
  openPubNubChannel: any;
  session_id: any;
  room: any;
  from: any;
  creatorId: any;
  adInfo: any;
  ip: any = null;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];
  eventHomeAdsRight: any[];
  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAds: any;
  streamInfoData: any;
  streamInfo: any = {};
  // creatorJoinTime: ReturnType<typeof setInterval> | undefined; //NodeJS.Timer;;
  timezoneVal: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commanSubscribeService: CommanSubscribeService,
    private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrService,
    private sbService: SendbirdService,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private pubnubService: PubNubService
  ) {
    this.room_id = this.route.snapshot.params.room_id
      ? this.route.snapshot.params.room_id
      : 0;
    if (this.room_id > 0) {
      this.ngxLoader.start();
    } else {
      this.ngxLoader.stop();
    }
    let id = this.route.snapshot.params.ticket_key,
      key: any;
    if (id.includes("-")) {
      this.key = id.split("-");
      this.event_id = this.key[0];
    } else {
      this.event_id = id;
    }
    // this.sbService.init();
    this.pubnubService.init();
    this.sb = this.sbService.sb;
    this.connectPubNubChannels();
  }

  ngOnInit() {
    this.timezoneVal = this.userService.getTimezone();
    let device = this.commanSubscribeService.getMobileOperatingSystem();
    if (device == "ios" || device == "android") {
      this.commanSubscribeService.sendScreenStatus(true);
    }
    this.route.queryParamMap.subscribe((queryParams) => {
      console.log("Data: ", queryParams);
      if (queryParams["params"].from) {
        this.from = queryParams["params"].from;
      }
      if (queryParams["params"].id) {
        this.creatorId = queryParams["params"].id;
      }
      console.log("from: ", this.from);
      console.log("creator: ", this.creatorId);
      console.log("roomId: ", this.room_id);
    });
    this.userInfo = this.commanSubscribeService.userInfo;
    this.ngxLoader.start();
    this.userInfoSubscription = this.commanSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.ngxLoader.stop();
        this.userInfo = response;
      });
    this.userInfoSubscription = this.commanSubscribeService
      .getSlugData()
      .subscribe((response) => {
        this.adInfo = response;
        this.eventDetails(this.adInfo);
      });
    this.getUserInfo();

    this.getTicketDetails();
    // this.getNetworkRoomsList('first');
    this.networkInterval = setInterval(() => {
      this.getNetworkRoomsList();
    }, 4 * 5000);
  }

  getTicketDetails() {
    this.ngxLoader.start();
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
      },
      response: true,
      body: {
        ticket_key: this.route.snapshot.params.ticket_key,
        timezone: this.timezoneVal,
      },
    };
    // this.ngxLoader.start();
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.GET_TICKET_DETAILS,
      data
    )
      .then((response) => {
        // this.ngxLoader.stop();
        if (response.data.statusCode === "200") {
          this.ticketInfo = response["data"]["Data"];
          this.getNetworkRoomsList("first");
          this.ngxLoader.stop();
        } else {
          this.toastr.error("Invalid link");
          this.router.navigateByUrl("/");
          this.ngxLoader.stop();
        }
      })
      .catch((e) => {
        this.ngxLoader.stop();
      });
  }

  getUserInfo() {
    this.ngxLoader.start();
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let splits = this.route.snapshot.params.ticket_key.split("-");
    let url = CONST_AWS_API.GET_CONTACT_DETAILS + "/" + splits[1];
    API.get(environment.AWS_Cognito.apiName, url, data)
      .then((response) => {
        // this.ngxLoader.stop();
        if (response.data.statusCode === "200") {
          let userInfo = response["data"]["Data"];
          userInfo.signedIn = true;
          userInfo.is_profile_completed = true;
          userInfo.access_token = this.userInfo.access_token;
          this.commanSubscribeService.sendUserInfo(userInfo);
          this.ngxLoader.stop();
        } else {
          this.ngxLoader.stop();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }
  getNetworkRoomsList(from?) {
    if (from == "first") this.ngxLoader.start();
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url = CONST_AWS_API.GET_ROOMS_LIST + "/" + this.event_id;
    // this.ngxLoader.start();
    API.get(environment.AWS_Cognito.apiName, url, data)
      .then((response) => {
        if (response.data.statusCode === "200") {
          console.log(response);
          // this.ngxLoader.stop();
          if (response.data.Data) this.rooms = response.data.Data || {};
          if (this.rooms && this.rooms.length > 0) {
            this.rooms.forEach((room) => {
              if (
                (this.ticketInfo &&
                  this.ticketInfo.networking.length > 0 &&
                  this.ticketInfo.networking.includes(Number(room.id))) ||
                this.ticketInfo.networking.includes("all")
              )
                room.isPurchased = true;
            });
          }
          if (from == "first")
            this.commanSubscribeService.sendSlugData(
              response["data"]["stream_info"]
            );
          if (this.room_id != 0) {
            this.creatorJoin();
          }
          if (from == "first") this.ngxLoader.stop();
        } else {
          if (from == "first") this.ngxLoader.stop();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }
  creatorJoin() {
    console.log("creatorJoin ::", this.userInfo);
    let room = this.rooms.filter((e) => e.id == this.room_id)[0] || {};
    if (room && this.isPubNubChannelAvailable) {
      this.joinRoom(room);
    } else {
      this.connectPubNubChannels(room);
    }
  }
  goToTickets() {
    this.router.navigateByUrl(
      `${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.ticketInfo.stream_info.slug}/place-order/${this.route.snapshot.params.ticket_key}`
    );
  }

  joinRoom(room) {
    this.ngxLoader.start();
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url = CONST_AWS_API.GET_NETWORK_ROOM_USERS + "/" + room.id;
    this.ngxLoader.start();
    API.get(environment.AWS_Cognito.apiName, url, data)
      .then((response) => {
        this.ngxLoader.stop();
        if (response.data.statusCode === "200") {
          console.log(response);
          // this.ngxLoader.stop();
          if (
            (this.ticketInfo.networking &&
              this.ticketInfo.networking.includes(Number(room.id))) ||
            this.ticketInfo.networking.includes("all")
          ) {
            this.networkUsers = response.data.Data || [];
            if (this.networkUsers.length > 0) {
              this.usersCount = this.networkUsers.filter((item: any) => {
                return item.is_session == 1;
              }).length;
              console.log("GGG", this.usersCount);
              if (this.usersCount < room.persons_allowed) {
                this.startSession(room);
              } else {
                this.toastr.info("Room is full");
                return;
              }
            } else {
              this.startSession(room);
            }
          } else {
            this.router.navigateByUrl(
              `${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.ticketInfo.stream_info.slug}/place-order/${this.route.snapshot.params.ticket_key}`
            );
          }
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }
  startSession(room) {
    if (room) {
      // if (room.room_status != 1) {
      //   this.toastr.info('Please wait for the host to start');
      //   return;
      // }
      this.ngxLoader.start();
      let contactInfo = {
        first_name: this.userInfo.user_first_name,
        last_name: this.userInfo.user_last_name,
        email: this.userInfo.email,
        phone_number: this.userInfo.user_phone_number,
      };
      let params = {
        startTime: new Date(),
        contact_details: contactInfo,
        is_session: 1,
        user_id: Number(this.userInfo.id),
        network_room_id: Number(room.id),
        event_id: this.event_id,
      };
      console.log("params", params);
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          Authorization: `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: params,
      };
      let url = CONST_AWS_API.START_NETWORK_ROOM_SESSION;
      API.post(environment.AWS_Cognito.apiName, url, data)
        .then((response) => {
          console.log("response", response);
          this.ngxLoader.stop();
          if (response.data.statusCode === "200") {
            this.session_id = response.data.Data;
            this.room = room;
            if (room.room_status == 0) {
              this.sendMessage(room);
            } else {
              let nav =
                this.room.host_manage_subroom == 1
                  ? "network-admin"
                  : "network-room";
              this.router.navigateByUrl(
                `${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${nav}/${this.room.id}/${this.session_id}/${this.route.snapshot.params.ticket_key}`
              );
            }
          } else {
            this.toastr.info("Something went wrong");
          }
        })
        .catch((error) => {
          this.toastr.error("Something went wrong");
          this.ngxLoader.stop();
        });
    }
  }
  connectPubNubChannels(room?) {
    // let user_id = this.userInfo.id;
    // if (this.userInfo.id == undefined) {
    let user_id = Number(this.key[1]);
    this.ngxLoader.start();
    // }
    this.pubnubService.connect(user_id.toString(), (error) => {
      if (error) {
        console.log("Error while connecting chat user", error);
        this.isPubNubChannelAvailable = false;
        // this.toastr.error("Error while connecting chat user");
        this.ngxLoader.stop();
        return;
      } else {
        this.pubnubService.enterChannel(
          this.event_id + "_notifications",
          1,
          (openChannel, error) => {
            if (error) {
              console.log("Error while connecting chat channel", error);
              this.isPubNubChannelAvailable = false;
              // this.toastr.error("Channel not available");
              this.ngxLoader.stop();
              return;
            }
            this.isPubNubChannelAvailable = true;
            this.openPubNubChannel = openChannel;
            this.ngxLoader.stop();
            if (room) this.joinRoom(room);
          }
        );
      }
    });
    // this.sbService.connect(
    //   user_id.toString(),
    //   environment.sendBird.SECONDARY_API_TOKENS,
    //   (error) => {
    //     if (error) {
    //       console.log("Error while connecting chat user", error);
    //       this.isSendBirdChannelAvailable = false;
    //       // this.toastr.error("Error while connecting chat user");
    //       this.ngxLoader.stop();
    //       return;
    //     } else {
    //       this.sbService.getOpenChannel(
    //         this.event_id + "_notifications",
    //         1,
    //         (openChannel, error) => {
    //           if (error) {
    //             console.log("Error while connecting chat channel", error);
    //             this.isSendBirdChannelAvailable = false;
    //             // this.toastr.error("Channel not available");
    //             this.ngxLoader.stop();
    //             return;
    //           }
    //           this.sbService.enterChannel(openChannel, 1, (response, error) => {
    //             if (error) {
    //               console.log("Error while enter chat channel", error);
    //               // this.toastr.error("Error while enter chat channel");
    //               this.isSendBirdChannelAvailable = false;
    //               this.ngxLoader.stop();
    //               return;
    //             }
    //             this.isSendBirdChannelAvailable = true;
    //             this.openSendBirdChannel = openChannel;
    //             this.ngxLoader.stop();
    //             if (room) this.joinRoom(room);
    //           });
    //         }
    //       );
    //     }
    //   }
    // );
  }

  reEnterChannel(error, params, callback) {
    console.error("RE-ENTERING CHANNEL");
    if (error) {
      this.pubnubService.connect(this.userInfo.id.toString(), (error) => {
        this.pubnubService.enterChannel(
          this.event_id + "_notifications",
          1,
          (openChannel, error) => {
            if (error) {
              callback(error);
            }
            this.openPubNubChannel = openChannel;
            this.pubnubService.sendMessage(
              this.event_id + "_notifications",
              params,
              (status, response) => {
                console.log("userMessage", response);
                console.log("userMessage error", status);
                callback(status.error);
              }
            );
          }
        );
      });
      // this.sbService.connect(
      //   this.userInfo.id.toString(),
      //   environment.sendBird.SECONDARY_API_TOKENS,
      //   (error) => {
      //     this.sbService.getOpenChannel(
      //       channelName,
      //       1,
      //       (openChannel, error) => {
      //         this.openSendBirdChannel = openChannel;
      //         this.sbService.enterChannel(
      //           this.openSendBirdChannel,
      //           1,
      //           (response, errorMsg) => {
      //             if (errorMsg) {
      //               // console.log("Error while enter chat channel", error);
      //               callback(errorMsg);
      //             } else {
      //               console.log("reconnect success");
      //               this.openSendBirdChannel.sendUserMessage(
      //                 params,
      //                 (userMessage, error) => {
      //                   console.log("userMessage", userMessage);
      //                   console.log("userMessage error", error);
      //                   callback(error);
      //                 }
      //               );
      //             }
      //           }
      //         );
      //       }
      //     );
      //   }
      // );
    } else {
      callback(error);
    }
  }
  sendMessage(room) {
    let sendMessageText = room.name + " - Networking Room started";
    if (!this.openPubNubChannel) {
      // this.toastr.error("Chat channels not connected");
      this.ngxLoader.start();
      return;
    }
    // this.ngxLoader.stop();
    if (sendMessageText) {
      room.from = this.from;
      room.creatorId = this.creatorId;
      const params = new this.sb.UserMessageParams();
      params.message = sendMessageText;
      params.messageId = Date.now();
      params.customType = "NETWORKING";
      params.data = JSON.stringify(room);
      params._sender = {
        profileUrl: this.userInfo.profie_pic || "",
        userId: this.userInfo.id,
        nickname: this.userInfo.user_display_name,
      };
      let nav =
        this.room.host_manage_subroom == 1 ? "network-admin" : "network-room";
      this.pubnubService.sendMessage(
        this.event_id + "_notifications",
        params,
        (status, response) => {
          if (status.error) {
            this.reEnterChannel(status.error, params, (err) => {
              if (err) {
                console.log("Error while sending message", err);
                this.toastr.error("Error while sending message");
                return;
              }
              this.ngxLoader.stop();
              this.router.navigateByUrl(
                `${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${nav}/${this.room.id}/${this.session_id}/${this.route.snapshot.params.ticket_key}`
              );
            });
          } else {
            this.ngxLoader.stop();
            this.router.navigateByUrl(
              `${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${nav}/${this.room.id}/${this.session_id}/${this.route.snapshot.params.ticket_key}`
            );
          }
          // this.messageList.push(userMessage);
        }
      );
      // this.openSendBirdChannel.sendUserMessage(params, (userMessage, error) => {
      //   console.log("userMessage11", userMessage);
      //   if (error) {
      //     this.reEnterChannel(error, params, (err) => {
      //       if (err) {
      //         console.log("Error while sending message", err);
      //         this.toastr.error("Error while sending message");
      //         return;
      //       }
      //       this.ngxLoader.stop();
      //       this.router.navigateByUrl(
      //         `/event/${nav}/${this.room.id}/${this.session_id}/${this.route.snapshot.params.ticket_key}`
      //       );
      //     });
      //   } else {
      //     this.ngxLoader.stop();
      //     this.router.navigateByUrl(
      //       `/event/${nav}/${this.room.id}/${this.session_id}/${this.route.snapshot.params.ticket_key}`
      //     );
      //   }
      //   // this.messageList.push(userMessage);
      // });
    }
  }
  loadAdsScript() {
    document
      .querySelectorAll(".videoAds")
      .forEach((vid) => (<HTMLVideoElement>vid).pause());
    $(".carousel-inner img").attr("alt", "");
    $(".carousel-inner img").attr("title", "");
    var t;
    var start = $("#myCarousel").find(".active").attr("id");
    t = setTimeout(
      "$('#myCarousel').carousel({interval: 1000});",
      start - 1000
    );
    $("#myCarousel").on("slid.bs.carousel", function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find(".active").attr("id");
      console.log(duration1);
      let slides = $(this).find(".carousel-item");
      let pvid = slides[ev.from].querySelectorAll("video")[0];
      if (pvid && (pvid != undefined || pvid != "undefined")) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll("video")[0];
      if (vid && (vid != undefined || vid != "undefined")) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $("#myCarousel").carousel("pause");
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    });
    $(".carousel-control-next").on("click", () => {
      clearTimeout(t);
    });
    $(".carousel-control-prev").on("click", () => {
      clearTimeout(t);
    });
    var r;
    var start = $("#RightCarousel").find(".active").attr("id");
    r = setTimeout(
      "$('#RightCarousel').carousel({interval: 1000});",
      start - 1000
    );
    $("#RightCarousel").on("slid.bs.carousel", function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find(".active").attr("id");
      console.log(duration2);
      let slides = $(this).find(".carousel-item");
      let pvid = slides[ev.from].querySelectorAll("video")[0];
      if (pvid && (pvid != undefined || pvid != "undefined")) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll("video")[0];
      if (vid && (vid != undefined || vid != "undefined")) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $("#RightCarousel").carousel("pause");
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    });
    $(".carousel-control-next").on("click", () => {
      clearTimeout(r);
    });
    $(".carousel-control-prev").on("click", () => {
      clearTimeout(r);
    });
  }

  eventDetails(adInfo) {
    this.streamAds = adInfo["stream_info"]["stream_ads"];
    console.log("All ads from dynamo", this.streamAds);
    this.streamAdsData = [];
    if (this.streamAds && this.streamAds.length > 0) {
      this.streamAds.forEach((element) => {
        if (
          (element.ad_size && element.ad_size == "728x90") ||
          element.ad_size == "300x600"
        ) {
          this.streamAdsData.push(element);
        }
      });
      console.log("Schedule page ads from dynamo", this.streamAdsData);
      if (this.streamAdsData.length > 0) {
        this.getAds();
      }
    }
  }
  selectedAdData: any;
  async getAds() {
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      this.sponsorData = this.streamAdsData;
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach((el) => {
        temp_site_id = Number(el.site_id);
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          divName: "div" + i + j,
          networkId: Number(environment.kevel.NETWORK_ID),
          siteId: Number(el.site_id),
          adTypes: [el.adTypeId],
          campaignId: Number(el.campaignId),
          flightId: Number(el.flight_id),
          adId: Number(el.ad_id),
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          let data = {
            placements: placements,
            allDiv: allDiv,
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.commanSubscribeService.getAdsData(data, (err, result) => {
              this.preloadAdsdata = result.Ads_data;
              console.log("Schedule page Ads :::: ", this.preloadAdsdata);
              if (this.preloadAdsdata.length > 0) {
                this.preloadAdsdata.forEach((element) => {
                  this.selectedAdData = element.clickUrl;
                  console.log(
                    "eventHomeAdsRight selectedAdData :: ",
                    this.selectedAdData
                  );
                  if (
                    element.contents &&
                    element.contents[0] &&
                    element.contents[0].body &&
                    element.width == 728 &&
                    element.height == 90
                  ) {
                    let adType = element.contents[0];
                    let customData = adType.data["customData"]
                      ? adType.data["customData"]
                      : {};
                    let duration = adType["data"]["customData"]["maxPlayTime"];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(
                      adType.body
                    );
                    this.eventHomeAdsTop.push({
                      image: this.adVideo,
                      duration: duration * 1000,
                    });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(
                        element.impressionUrl
                      );
                    }
                  }
                  if (
                    element.contents &&
                    element.contents[0] &&
                    element.contents[0].body &&
                    element.width == 300 &&
                    element.height == 600
                  ) {
                    let adType = element.contents[0];
                    // let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType["data"]["customData"]["maxPlayTime"];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(
                      adType.body
                    );
                    this.eventHomeAdsRight.push({
                      image: rightsadVideo,
                      duration: duration * 1000,
                    });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(
                        element.impressionUrl
                      );
                    }
                  }
                });
                console.log("scheduleAdsTop :: ", this.eventHomeAdsTop);
                console.log("scheduleAdsRight :: ", this.eventHomeAdsRight);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }
            });
          }
        }
      });
    }
  }
  ngOnDestroy() {
    this.pubnubService.disconnect([this.event_id + "_notifications"]);
    if (this.networkInterval) {
      clearInterval(this.networkInterval);
    }
    // if (this.creatorJoinTime) {
    //   clearInterval(this.creatorJoinTime);
    // }
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
  }
}
